import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/analytics-1.4-apis/analytics-1.4-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pathing-reports"
    }}>{`Pathing Reports`}</h1>
    <p>{`There are two kinds of pathing reports, "Pathing" and "Fallout".`}</p>
    <h2 {...{
      "id": "pathing-report-using-pattern"
    }}>{`Pathing Report (using `}<inlineCode parentName="h2">{`"pattern"`}</inlineCode>{`)`}</h2>
    <p>{`A pathing report is generated by combining up to five patterns in a list to specify a match. For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"pattern": [
    ["videoPage5"],
    ["::anything::"],
    ["::anything::"],
    ["::anything::"],
    ["::anything::"]
] 
`}</code></pre>
    <p>{`Using the names of pages on you site along with the special page names in the following table, you can generate a number of useful pathing reports.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Meaning`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`::anything::`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any page, including entered and existed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`::not_entered::`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Anything except entered the site`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`::not_exited::`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Anything expect exited the site`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`::entered::`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Entered the site`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`::exited::`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Exited the site`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`::not::`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Used before a value to negate it. For example, `}<inlineCode parentName="td">{`"::not::","page1"`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "fallout-report-using-checkpoints"
    }}>{`Fallout Report (using `}<inlineCode parentName="h2">{`"checkpoints"`}</inlineCode>{`)`}</h2>
    <p>{`Fallout reports can be generated for the Visits metric using `}<inlineCode parentName="p">{`page`}</inlineCode>{`, `}<inlineCode parentName="p">{`sitesection`}</inlineCode>{`, or a `}<inlineCode parentName="p">{`prop`}</inlineCode>{` (if pathing is enabled). To generate a fallout report, provide a list of up to 8 values to use as checkpoints. The number of pageviews returned for each checkpoint indicates the number of pageviews that successfully satisfied all checkpoints up to and including that point.`}</p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "reportSuiteID": "rsid",
  "dateFrom": "YYYY-01-01",
  "dateTo": "YYYY-01-02",
  "metrics": [
    {
      "id": "pageviews" //This metric is required for all fallout reports. It is the only metric currently supported.
    }
  ],
  "elements": [
    {
      "id": "page", //Only 1 element can be specified. Valid elements are page, sitesection, and prop## (if pathing enabled).
      "checkpoints": [        //This is the list of checkpoints (Maximum 8 items)
        "videoPage3",
        "videoPage2",
        "videoPage1"
      ]
    }
  ],
  "locale": "en_US"
}
`}</code></pre>
    <h4 {...{
      "id": "response"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`
{
  "type": "fallout",
  "elements": [
    {
      "id": "page",
      "name": "Page"
    }
  ],
  "reportSuite": {
    "id": "rsid",
    "name": "my report suite"
  },
  "period": "Wed. 1 Jan. YYYY - Thu. 2 Jan. YYYY",
  "metrics": [
    {
      "id": "pageviews",
      "name": "Page Views",
      "type": "number",
      "decimals": 0,
      "latency": 205,
      "current": false
    }
  ],
  "data": [
    {
      "name": "videoPage3",
      "url": "http://example.com/videoPage3",
      "counts": [
        "191"             //This is the total number of visits
      ]
    },
    {
      "name": "videoPage2",
      "url": "http://example.com/videoPage2",
      "counts": [
        "53"                //This is the number of visits that continued (27%)
      ]                     //Meaning that 130 exited the site (73%)
    },
    {
      "name": "videoPage1",
      "url": "http://example.com/videoPage1",
      "counts": [
        "20"                //This is the number of visits that continued (37%)
      ]                     //Meaning that 33 exited the site (63%)
    }
  ],
  "totals": null,
  "version": "1.4"
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      